import { render, staticRenderFns } from "./TeacherStudents.vue?vue&type=template&id=7e095c5e&scoped=true&"
import script from "./TeacherStudents.vue?vue&type=script&lang=js&"
export * from "./TeacherStudents.vue?vue&type=script&lang=js&"
import style0 from "./TeacherStudents.vue?vue&type=style&index=0&id=7e095c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e095c5e",
  null
  
)

export default component.exports